import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import heroImage from '../../assets/customer-story-zervant-hero.webp';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStoryZervantPage.css';

export const SuccessStoryZervantPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStoryZervant.schemaTitle' });
  const schemaDescription = intl.formatMessage({ id: 'SuccessStoryZervant.schemaDescription' });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const MAX_MOBILE_SCREEN_WIDTH = 962;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStoryZervantPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroSection}>
            <div className={css.heroSectionLeft}>
              <div className={css.heroSectionBreadcrumbs}>
                <NamedLink name="SuccessStoriesPage">
                  <FormattedMessage id="SuccessStoryZervant.heroBreadcrumbs1" />
                </NamedLink>
                <FormattedMessage id="SuccessStoryZervant.heroBreadcrumbs2" />
                <FormattedMessage id="SuccessStoryZervant.heroBreadcrumbs3" />
              </div>
              {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.heroSectionMobile}>
                  <img
                    src={heroImage}
                    alt="Hero"
                    className={css.proInfoSectionContentImage}
                    loading="lazy"
                  />
                </div>
              ) : null}
              <div className={css.heroSectionTitle}>
                <FormattedMessage id="SuccessStoryZervant.heroTitle" />
              </div>
              <div className={css.heroSectionText}>
                <FormattedMessage id="SuccessStoryZervant.heroText" />
              </div>
              <div className={css.heroSectionTags}>
                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryZervant.heroTag1" />
                </div>

                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryZervant.heroTag2" />
                </div>
              </div>
            </div>
            {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
              <div className={css.heroSectionRight}>
                <img
                  src={heroImage}
                  alt="Hero"
                  className={css.proInfoSectionContentImage}
                  loading="lazy"
                />
              </div>
            ) : null}
          </div>
          <div className={css.sections}>
            <div className={css.contentSection}>
              <div className={css.contentSectionContent}>
                <div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionTitle1" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryZervant.contentSectionParagraph11"
                        values={{
                          a: chunks => (
                            <a
                              href="https://www.zervant.com/fi/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph12" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryZervant.contentSectionParagraph13"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                    <div className={css.articleBlockWithBG}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Name" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Company" />
                    </div>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionTitle2" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph21" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryZervant.contentSectionParagraph22"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph23" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph24" />
                    </p>
                  </article>
                  {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                    <div className={css.contentSectionCTAmobile}>
                      <div className={css.contentSectionCTAtitle}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                      </div>
                      <div className={css.contentSectionCTAtext}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                      </div>
                      <div className={css.contentSectionCTAbutton}>
                        <ExternalLink
                          className={css.contentSectionContactButton}
                          onClick={handleShowSpaceHome}
                        >
                          <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                        </ExternalLink>
                      </div>
                    </div>
                  ) : null}
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionTitle3" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph31" />
                    </p>
                    <div className={css.articleBlockWithBG}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph32" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Name" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Company" />
                    </div>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryZervant.contentSectionParagraph33"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph34" />
                    </p>
                  </article>
                  <div className={css.articleSectionResults}>
                    <div className={css.articleSectionResultsTitle}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionResultsTitle" />
                    </div>
                    <ul className={css.articleSectionResultsList}>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryZervant.contentSectionResultsListItem1" />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryZervant.contentSectionResultsListItem2" />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryZervant.contentSectionResultsListItem3" />
                      </li>
                    </ul>
                  </div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionTitle4" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph41" />
                    </p>
                    <div className={css.articleBlockWithBG}>
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph42" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Name" />
                      <FormattedMessage id="SuccessStoryZervant.contentSectionParagraph14Company" />
                    </div>
                  </article>
                </div>
              </div>
              {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.contentSectionCTAbar}>
                  <div className={css.contentSectionCTA}>
                    <div className={css.contentSectionCTAtitle}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                    </div>
                    <div className={css.contentSectionCTAtext}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                    </div>
                    <div className={css.contentSectionCTAbutton}>
                      <ExternalLink
                        className={css.contentSectionContactButton}
                        onClick={handleShowSpaceHome}
                      >
                        <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                      </ExternalLink>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <ContactPreFooter />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

SuccessStoryZervantPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { number, shape } = PropTypes;

SuccessStoryZervantPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStoryZervantPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(SuccessStoryZervantPageComponent);

export default SuccessStoryZervantPage;
